import type { ReactNode } from 'react';
import type { MultiTariffUpsaleRadioType } from 'reactApp/sections/QuotaLanding/multiTariffUpsaleDialog/models/MultiTariffUpsaleDialog.model.types';
import { MultiTariffUpsaleModelBase } from 'reactApp/sections/QuotaLanding/multiTariffUpsaleDialog/models/MultiTariffUpsaleDialogBase.model';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

export class FamilyMultiTariffUpsaleDialogModel extends MultiTariffUpsaleModelBase {
    override getTitle(): string {
        return 'Семейный тариф выгоднее — его можно использовать вчетвером';
    }

    override getTitleDescription(): string {
        return 'В этом тарифе есть семейные папки и альбомы, никакой рекламы в Почте и Облаке и безлимит для фото с телефонов';
    }

    override getPriorityCardLabelText(): string {
        return 'Семейный';
    }

    override getSecondaryCardLabelText(): string {
        switch (this.activeTab) {
            case ETabsName.basic:
                return 'Минимальный';
            case ETabsName.advanced:
            default:
                return 'Основной';
        }
    }

    override getSecondaryCardLabelVisible(): boolean {
        return true;
    }

    override getPriorityCardTopTitle(): ReactNode {
        return `+${this.product.space.value}`;
    }

    override getSecondaryCardTopTitle(): ReactNode {
        return `+${this.product.space.value}`;
    }

    override getDwh(selected: MultiTariffUpsaleRadioType) {
        const dwh = super.getDwh(selected);
        return { ...dwh, action: 'modal-upsale-family', selectedPeriod: this.product.period === '1m' ? 'month' : 'year' };
    }
}
